// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"ChangeDesignPriority_linkButton__3hlGc"};